<script lang="ts" setup>
import { container as ModalsContainer } from 'jenesius-vue-modal'

const updateHeight = () => {
  const container = document.querySelector('#modal-wrapper')?.querySelector('.modal-container')
  if (container) {
    (container as HTMLDivElement).style.height = (window.visualViewport?.height ?? window.innerHeight) + 'px'
    ;(container as HTMLDivElement).style.top = (window.visualViewport?.offsetTop ?? 0) + 'px'
  }
}

onMounted(() => {
  window.addEventListener('resize', updateHeight)
  window.visualViewport?.addEventListener('resize', updateHeight)
  window.visualViewport?.addEventListener('scroll', updateHeight)
  document.addEventListener('focusin', updateHeight)
  document.addEventListener('focusout', updateHeight)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateHeight)
  window.visualViewport?.removeEventListener('resize', updateHeight)
  window.visualViewport?.removeEventListener('scroll', updateHeight)
  document.removeEventListener('focusin', updateHeight)
  document.removeEventListener('focusout', updateHeight)
})

</script>

<template>
  <ClientOnly>
    <Teleport to="body">
      <ModalsContainer id="modal-wrapper" />
    </Teleport>
  </ClientOnly>
</template>
